import React, { FC, useState, useMemo } from "react";
import SearchInput from "./SearchInput";
import OptionGrid from "./OptionGrid";
import NoSearchResults from "./NoSearchResults";
import styles from "../../../styles/B2C/StepLayout.module.scss";
import { useWizardOptions } from "../../../context/WizardOptionsContext";

interface FieldOfStudyStepProps {
  selected: string[];
  onSelect: (areas: string[]) => void;
}

const FieldOfStudyStep: FC<FieldOfStudyStepProps> = ({
  selected,
  onSelect,
}) => {
  const { studyAreas } = useWizardOptions();
  const areaNames = useMemo(
    () => (studyAreas ?? []).map((studyArea) => studyArea.label),
    [studyAreas]
  );

  const [search, setSearch] = useState("");

  const filteredAreas = useMemo(() => {
    if (!search.trim()) return areaNames;
    return areaNames.filter((areaName) =>
      areaName.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, areaNames]);

  const handleSelect = (area: string) => {
    if (selected.includes(area)) {
      onSelect(selected);
    } else {
      onSelect([area]);
    }
  };

  return (
    <div className={styles.stepContent}>
      <SearchInput
        value={search}
        onChange={setSearch}
        placeholder="Search..."
      />
      {search.trim() !== "" && filteredAreas.length === 0 ? (
        <NoSearchResults />
      ) : (
        <OptionGrid
          options={filteredAreas}
          selected={selected}
          onSelect={handleSelect}
          multiSelect
        />
      )}
    </div>
  );
};

export default FieldOfStudyStep;
